module.exports = function(column) {

  return  this.query.hasOwnProperty(column) &&
          this.opts.dateColumns.indexOf(column)==-1 &&
         !this.opts.listColumns.hasOwnProperty(column);
}



// WEBPACK FOOTER //
// ./~/vue-tables-2/lib/methods/is-text-filter.js